import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { documentsApi } from '../../../lib/api/documentsApi.connect';
export function useVersions(documentId) {
    return useQuery({
        queryKey: [
            'editor-versions',
            documentId
        ],
        queryFn: ()=>documentId ? documentsApi.listVersions(documentId) : Promise.reject(new Error('no document id')),
        enabled: !!documentId
    });
}
export function useRestoreVersion() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ documentId, versionId, baseVersionId })=>documentsApi.restoreVersion(documentId, versionId, baseVersionId),
        onSuccess: (_doc, vars)=>{
            qc.invalidateQueries({
                queryKey: [
                    'editor-versions',
                    vars.documentId
                ]
            });
            qc.invalidateQueries({
                queryKey: [
                    'editor-document',
                    vars.documentId
                ]
            });
            qc.invalidateQueries({
                queryKey: [
                    'editor-documents'
                ]
            });
        }
    });
}
